export interface NumberRange {
  from: number;
  to: number;
}
